import React, { useState, useEffect, useReducer, useContext } from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TextField from "@material-ui/core/TextField";
import IconButton from "@material-ui/core/IconButton";
import Chip from "@material-ui/core/Chip";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import CircularProgress from "@material-ui/core/CircularProgress";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Tooltip from "@material-ui/core/Tooltip";
import Grid from "@material-ui/core/Grid";
import ChatiaPopover, { PopoverOptionItem } from "../../components/ChatiaPopover";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import EditIcon from "@material-ui/icons/Edit";
import AddIcon from "@material-ui/icons/Add";
import FileCopyOutlinedIcon from "@material-ui/icons/FileCopyOutlined";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";
import MainHeaderButtonsWrapper from "../../components/MainHeaderButtonsWrapper";
import Title from "../../components/Title";
import ChatiaDialog, { ChatiaPromptField, ChatiaToggleItem } from "../../components/ChatiaDialog";
import { SelectArrowIcon } from "../../components/ChatiaIcons";
import ConfirmationModal from "../../components/ConfirmationModal";
import api from "../../services/api";
import toastError from "../../errors/toastError";
import { toast } from "react-toastify";
import { AuthContext } from "../../context/Auth/AuthContext";
import ForbiddenPage from "../../components/ForbiddenPage";
import usePlans from "../../hooks/usePlans";

// ==================== ICONS ====================
const ConfigIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" {...props}>
    <path d="M21.3175 7.14139L20.8239 6.28479C20.4506 5.63696 20.264 5.31305 19.9464 5.18388C19.6288 5.05472 19.2696 5.15664 18.5513 5.36048L17.3311 5.70418C16.8725 5.80994 16.3913 5.74994 15.9726 5.53479L15.6357 5.34042C15.2766 5.11043 15.0004 4.77133 14.8475 4.37274L14.5136 3.37536C14.294 2.71534 14.1842 2.38533 13.9228 2.19657C13.6615 2.00781 13.3143 2.00781 12.6199 2.00781H11.5051C10.8108 2.00781 10.4636 2.00781 10.2022 2.19657C9.94085 2.38533 9.83106 2.71534 9.61149 3.37536L9.27753 4.37274C9.12465 4.77133 8.84845 5.11043 8.48937 5.34042L8.15249 5.53479C7.73374 5.74994 7.25259 5.80994 6.79398 5.70418L5.57375 5.36048C4.85541 5.15664 4.49625 5.05472 4.17867 5.18388C3.86109 5.31305 3.67445 5.63696 3.30115 6.28479L2.80757 7.14139C2.45766 7.74864 2.2827 8.05227 2.31666 8.37549C2.35061 8.69871 2.58483 8.95918 3.05326 9.48012L4.0843 10.6328C4.3363 10.9518 4.51521 11.5078 4.51521 12.0077C4.51521 12.5078 4.33636 13.0636 4.08433 13.3827L3.05326 14.5354C2.58483 15.0564 2.35062 15.3168 2.31666 15.6401C2.2827 15.9633 2.45766 16.2669 2.80757 16.8741L3.30114 17.7307C3.67443 18.3785 3.86109 18.7025 4.17867 18.8316C4.49625 18.9608 4.85542 18.8589 5.57377 18.655L6.79394 18.3113C7.25263 18.2055 7.73387 18.2656 8.15267 18.4808L8.4895 18.6752C8.84851 18.9052 9.12464 19.2442 9.2775 19.6428L9.61149 20.6403C9.83106 21.3003 9.94085 21.6303 10.2022 21.8191C10.4636 22.0078 10.8108 22.0078 11.5051 22.0078H12.6199C13.3143 22.0078 13.6615 22.0078 13.9228 21.8191C14.1842 21.6303 14.294 21.3003 14.5136 20.6403L14.8476 19.6428C15.0004 19.2442 15.2765 18.9052 15.6356 18.6752L15.9724 18.4808C16.3912 18.2656 16.8724 18.2055 17.3311 18.3113L18.5513 18.655C19.2696 18.8589 19.6288 18.9608 19.9464 18.8316C20.264 18.7025 20.4506 18.3785 20.8239 17.7307L21.3175 16.8741C21.6674 16.2669 21.8423 15.9633 21.8084 15.6401C21.7744 15.3168 21.5402 15.0564 21.0718 14.5354L20.0407 13.3827C19.7887 13.0636 19.6098 12.5078 19.6098 12.0077C19.6098 11.5078 19.7888 10.9518 20.0407 10.6328L21.0718 9.48012C21.5402 8.95918 21.7744 8.69871 21.8084 8.37549C21.8423 8.05227 21.6674 7.74864 21.3175 7.14139Z" />
    <path d="M15.5195 12C15.5195 13.933 13.9525 15.5 12.0195 15.5C10.0865 15.5 8.51953 13.933 8.51953 12C8.51953 10.067 10.0865 8.5 12.0195 8.5C13.9525 8.5 15.5195 10.067 15.5195 12Z" />
  </svg>
);

const CartAbandonIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M14 20H9.58272C7.1552 20 5.94145 20 5.10221 19.2891C4.26297 18.5781 4.06343 17.3809 3.66435 14.9864L2.49995 8H21.5L20.6666 13" />
    <path d="M12 12V16" />
    <path d="M8 12V16" />
    <path d="M22.5 8H1.5" />
    <path d="M18 8L15 3" />
    <path d="M6 8L9 3" />
    <path d="M22 16L17 21M17 16L22 21" />
  </svg>
);

// ==================== REDUCER ====================
const mappingReducer = (state, action) => {
  if (action.type === "LOAD_MAPPINGS") return action.payload;
  if (action.type === "ADD_MAPPING") return [...state, action.payload];
  if (action.type === "UPDATE_MAPPING") return state.map((m) => (m.id === action.payload.id ? action.payload : m));
  if (action.type === "DELETE_MAPPING") return state.filter((m) => m.id !== action.payload);
  return state;
};

// ==================== CONSTANTS ====================
const DEFAULT_ABANDONMENT_MSG = `Oi {{nome}}! 👋

Vi que você se interessou pelo *{{produto}}* mas não finalizou a compra.

Posso te ajudar com alguma dúvida? 😊

Se quiser finalizar, é só acessar:
{{link}}`;

const DEFAULT_PIX_MSG = `Oi {{nome}}! 😊

Vi que você gerou um PIX para o *{{produto}}* mas o pagamento ainda está pendente.

Assim que você pagar, vamos liberar seu acesso aqui pelo WhatsApp!

Se ainda não pagou, segue o PIX abaixo para facilitar 👇`;

const DEFAULT_OVERDUE_MSG = `Oi {{nome}}! 👋

Identificamos que o pagamento da sua assinatura do *{{produto}}* está pendente.

Por favor, regularize para evitar a suspensão do seu acesso.

Se já efetuou o pagamento, desconsidere esta mensagem. 😊`;

const DEFAULT_DEACTIVATION_MSG = `Oi {{nome}},

Infelizmente seu acesso ao *{{produto}}* foi desativado por falta de pagamento.

Para reativar, basta falar com nossa equipe por aqui mesmo! Estamos à disposição. 😊`;

const DEFAULT_ACCESS_MSG = `Oi {{nome}}! 🎉

Seu acesso ao sistema foi criado com sucesso!

📧 *Email:* {{email}}
🔑 *Senha:* {{senha}}
🔗 *Link:* {{link}}

Acesse agora e comece a usar! 😊`;

const DEFAULT_REACTIVATION_MSG = `Oi {{nome}}! 🎉

Seu acesso foi reativado com sucesso!

📧 *Email:* {{email}}
🔗 *Link:* {{link}}

Acesse com sua senha anterior. Se esqueceu, use a opção de recuperação. 😊`;

const recurrenceToDays = (rec) => {
  const map = { weekly: 7, biweekly: 15, monthly: 30, quarterly: 90, semiannual: 180, annual: 365 };
  return map[rec] || 30;
};

// ==================== STYLES ====================
const useStyles = makeStyles((theme) => ({
  mainPaper: {
    flex: 1,
    padding: theme.spacing(2),
    overflowY: "auto",
    ...theme.scrollbarStyles,
  },
  cardsArea: {
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(2),
    padding: theme.spacing(1, 0),
  },
  integrationCard: {
    position: "relative",
    padding: theme.spacing(3, 3),
    borderRadius: 18,
    border: theme.palette.type === "dark"
      ? "1px solid rgba(139,92,246,0.25)"
      : "1px solid rgba(139,92,246,0.15)",
    cursor: "pointer",
    transition: "all 0.25s ease",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    gap: theme.spacing(1.5),
    width: 300,
    background: theme.palette.type === "dark"
      ? "linear-gradient(160deg, rgba(99,102,241,0.10) 0%, rgba(139,92,246,0.04) 60%, transparent 100%)"
      : "linear-gradient(160deg, rgba(99,102,241,0.07) 0%, rgba(139,92,246,0.03) 60%, rgba(255,255,255,1) 100%)",
    "&:hover": {
      boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
    },
    "&:hover $cardMenuBtn": {
      opacity: 1,
    },
  },
  cardLogo: {
    width: 110,
    height: 110,
    borderRadius: 18,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    overflow: "hidden",
    padding: 8,
  },
  cardMenuBtn: {
    opacity: 0,
    transition: "opacity 0.2s ease",
    position: "absolute",
    top: 8,
    right: 8,
  },
  countryFlag: {
    position: "absolute",
    top: 10,
    left: 10,
    width: 24,
    height: "auto",
    borderRadius: 3,
    boxShadow: "0 1px 3px rgba(0,0,0,0.15)",
  },
  selectMenu: {
    borderRadius: "12px !important",
    boxShadow: "0 2px 12px rgba(0,0,0,0.08) !important",
    "& .MuiList-root": {
      padding: 4,
      ...theme.scrollbarStyles,
    },
    "& .MuiMenuItem-root": {
      borderRadius: 7,
      fontSize: 14,
      "&:hover": {
        backgroundColor: theme.mode === "light" ? "#f5f0eb !important" : "#2a3942 !important",
      },
      "&.Mui-selected": {
        backgroundColor: "rgba(6, 207, 156, 0.10) !important",
      },
      "&.Mui-selected:hover": {
        backgroundColor: "rgba(6, 207, 156, 0.15) !important",
      },
    },
  },
  section: {
    padding: theme.spacing(2.5),
    marginBottom: theme.spacing(2),
    borderRadius: 16,
    border: `1px solid ${theme.palette.divider}`,
  },
  sectionTitle: { fontWeight: 600, marginBottom: theme.spacing(1) },
  sectionSubtitle: { color: theme.palette.text.secondary, fontSize: "0.85rem", marginBottom: theme.spacing(1.5) },
  webhookUrl: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    marginTop: theme.spacing(1),
    padding: theme.spacing(1.5),
    borderRadius: 12,
    backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.04)",
    fontFamily: "monospace",
    fontSize: "0.9rem",
    wordBreak: "break-all",
  },
  loadingContainer: { display: "flex", justifyContent: "center", alignItems: "center", padding: theme.spacing(3) },
  variableChip: {
    margin: theme.spacing(0.5),
    cursor: "pointer",
    fontFamily: "monospace",
    fontSize: "0.8rem",
  },
}));

// ==================== COMPONENT ====================
const PaymentConfig = () => {
  const classes = useStyles();
  const theme = useTheme();
  const { user: loggedInUser } = useContext(AuthContext);
  const { list: listPlans } = usePlans();

  const [view, setView] = useState("cards");
  const [menuAnchor, setMenuAnchor] = useState(null);

  // Mappings
  const [mappings, dispatch] = useReducer(mappingReducer, []);
  const [plans, setPlans] = useState([]);
  const [mappingLoading, setMappingLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [selectedMapping, setSelectedMapping] = useState(null);
  const [deletingMapping, setDeletingMapping] = useState(null);
  const [formData, setFormData] = useState({
    platform: "braip", externalProductId: "", externalPlanId: "", externalProductName: "", planId: "", durationDays: 30, billingType: "recurring", recurrence: "monthly", autoActivate: true,
  });

  // Messages dialog
  const [messagesDialogOpen, setMessagesDialogOpen] = useState(false);
  const [messagesLoading, setMessagesLoading] = useState(false);
  const [agentName, setAgentName] = useState("");
  // Abandono
  const [abandonEnabled, setAbandonEnabled] = useState(true);
  const [abandonMessage, setAbandonMessage] = useState(DEFAULT_ABANDONMENT_MSG);
  // PIX
  const [pixEnabled, setPixEnabled] = useState(false);
  const [pixDelay, setPixDelay] = useState(5);
  const [pixMessage, setPixMessage] = useState(DEFAULT_PIX_MSG);
  // Acesso
  const [accessEnabled, setAccessEnabled] = useState(true);
  const [accessMessage, setAccessMessage] = useState(DEFAULT_ACCESS_MSG);
  const [reactivationEnabled, setReactivationEnabled] = useState(true);
  const [reactivationMessage, setReactivationMessage] = useState(DEFAULT_REACTIVATION_MSG);
  // Cobrança
  const [overdueEnabled, setOverdueEnabled] = useState(true);
  const [overdueMessage, setOverdueMessage] = useState(DEFAULT_OVERDUE_MSG);
  const [overdueDelay, setOverdueDelay] = useState(1);
  const [overdueRepeat, setOverdueRepeat] = useState(false);
  const [overdueRepeatTimes, setOverdueRepeatTimes] = useState(3);
  const [overdueRepeatInterval, setOverdueRepeatInterval] = useState(2);
  // Desativação
  const [deactivationEnabled, setDeactivationEnabled] = useState(true);
  const [deactivationMessage, setDeactivationMessage] = useState(DEFAULT_DEACTIVATION_MSG);

  const backendUrl = process.env.REACT_APP_BACKEND_URL || window.location.origin;

  const mappingSelectMenuProps = {
    classes: { paper: classes.selectMenu },
    anchorOrigin: { vertical: "bottom", horizontal: "left" },
    transformOrigin: { vertical: "top", horizontal: "left" },
    getContentAnchorEl: null,
    PaperProps: { style: { marginTop: 5 } },
  };

  useEffect(() => {
    fetchMappings();
    fetchPlans();
    fetchMessageSettings();
  }, []);

  // ==================== MAPPINGS ====================
  const fetchMappings = async () => {
    setMappingLoading(true);
    try {
      const { data } = await api.get("/product-plan-mappings");
      dispatch({ type: "LOAD_MAPPINGS", payload: data });
    } catch (err) { toastError(err); } finally { setMappingLoading(false); }
  };

  const fetchPlans = async () => { try { setPlans(await listPlans() || []); } catch (_) {} };

  const handleOpenModal = (mapping = null) => {
    if (mapping) {
      setSelectedMapping(mapping);
      setFormData({ platform: mapping.platform, externalProductId: mapping.externalProductId, externalPlanId: mapping.externalPlanId || "", externalProductName: mapping.externalProductName || "", planId: mapping.planId, durationDays: mapping.durationDays, billingType: mapping.billingType || "recurring", recurrence: mapping.recurrence || "monthly", autoActivate: mapping.autoActivate });
    } else {
      setSelectedMapping(null);
      setFormData({ platform: "braip", externalProductId: "", externalPlanId: "", externalProductName: "", planId: "", durationDays: 30, billingType: "recurring", recurrence: "monthly", autoActivate: true });
    }
    setModalOpen(true);
  };

  const handleSaveMapping = async () => {
    if (!formData.externalProductId && !formData.externalPlanId) { toast.error("Preencha o Product Key ou o Plan Key."); return; }
    if (!formData.planId) { toast.error("Selecione um plano."); return; }
    try {
      if (selectedMapping) {
        const { data } = await api.put(`/product-plan-mappings/${selectedMapping.id}`, formData);
        dispatch({ type: "UPDATE_MAPPING", payload: data });
        toast.success("Mapeamento atualizado!");
      } else {
        const { data } = await api.post("/product-plan-mappings", formData);
        dispatch({ type: "ADD_MAPPING", payload: data });
        toast.success("Mapeamento criado!");
      }
      setModalOpen(false); setSelectedMapping(null);
    } catch (err) { toastError(err); }
  };

  const handleDeleteMapping = async (id) => {
    try { await api.delete(`/product-plan-mappings/${id}`); dispatch({ type: "DELETE_MAPPING", payload: id }); toast.success("Removido!"); } catch (err) { toastError(err); }
    setConfirmOpen(false); setDeletingMapping(null);
  };

  const getPlanName = (id) => { const p = plans.find((x) => x.id === id); return p ? p.name : `Plano #${id}`; };
  const handleCopyUrl = (url) => { navigator.clipboard.writeText(url); toast.success("URL copiada!"); };

  // ==================== MESSAGE SETTINGS ====================
  const fetchMessageSettings = async () => {
    try {
      const keys = ["braipAbandonmentMessage", "braipAbandonmentEnabled", "braipPixMessage", "braipPixEnabled", "braipPixDelay", "braipAgentName", "braipAccessMessage", "braipAccessEnabled", "braipReactivationMessage", "braipReactivationEnabled", "braipOverdueMessage", "braipOverdueEnabled", "braipOverdueDelay", "braipOverdueRepeat", "braipOverdueRepeatTimes", "braipOverdueRepeatInterval", "braipDeactivationMessage", "braipDeactivationEnabled"];
      const results = await Promise.allSettled(keys.map((k) => api.get(`/settings/${k}`)));
      results.forEach((r, i) => {
        if (r.status !== "fulfilled" || !r.value?.data?.value) return;
        const val = r.value.data.value;
        if (keys[i] === "braipAbandonmentMessage") setAbandonMessage(val);
        if (keys[i] === "braipAbandonmentEnabled") setAbandonEnabled(val === "true");
        if (keys[i] === "braipPixMessage") setPixMessage(val);
        if (keys[i] === "braipPixEnabled") setPixEnabled(val === "true");
        if (keys[i] === "braipPixDelay") setPixDelay(parseInt(val) || 5);
        if (keys[i] === "braipAgentName") setAgentName(val);
        if (keys[i] === "braipAccessMessage") setAccessMessage(val);
        if (keys[i] === "braipAccessEnabled") setAccessEnabled(val === "true");
        if (keys[i] === "braipReactivationMessage") setReactivationMessage(val);
        if (keys[i] === "braipReactivationEnabled") setReactivationEnabled(val === "true");
        if (keys[i] === "braipOverdueMessage") setOverdueMessage(val);
        if (keys[i] === "braipOverdueEnabled") setOverdueEnabled(val === "true");
        if (keys[i] === "braipOverdueDelay") setOverdueDelay(parseInt(val) || 1);
        if (keys[i] === "braipOverdueRepeat") setOverdueRepeat(val === "true");
        if (keys[i] === "braipOverdueRepeatTimes") setOverdueRepeatTimes(parseInt(val) || 3);
        if (keys[i] === "braipOverdueRepeatInterval") setOverdueRepeatInterval(parseInt(val) || 2);
        if (keys[i] === "braipDeactivationMessage") setDeactivationMessage(val);
        if (keys[i] === "braipDeactivationEnabled") setDeactivationEnabled(val === "true");
      });
    } catch (_) {}
  };

  const handleSaveMessageSettings = async () => {
    setMessagesLoading(true);
    try {
      await Promise.all([
        api.put("/settings/braipAbandonmentMessage", { value: abandonMessage }),
        api.put("/settings/braipAbandonmentEnabled", { value: String(abandonEnabled) }),
        api.put("/settings/braipPixMessage", { value: pixMessage }),
        api.put("/settings/braipPixEnabled", { value: String(pixEnabled) }),
        api.put("/settings/braipPixDelay", { value: String(pixDelay) }),
        api.put("/settings/braipAgentName", { value: agentName }),
        api.put("/settings/braipAccessMessage", { value: accessMessage }),
        api.put("/settings/braipAccessEnabled", { value: String(accessEnabled) }),
        api.put("/settings/braipReactivationMessage", { value: reactivationMessage }),
        api.put("/settings/braipReactivationEnabled", { value: String(reactivationEnabled) }),
        api.put("/settings/braipOverdueMessage", { value: overdueMessage }),
        api.put("/settings/braipOverdueEnabled", { value: String(overdueEnabled) }),
        api.put("/settings/braipOverdueDelay", { value: String(overdueDelay) }),
        api.put("/settings/braipOverdueRepeat", { value: String(overdueRepeat) }),
        api.put("/settings/braipOverdueRepeatTimes", { value: String(overdueRepeatTimes) }),
        api.put("/settings/braipOverdueRepeatInterval", { value: String(overdueRepeatInterval) }),
        api.put("/settings/braipDeactivationMessage", { value: deactivationMessage }),
        api.put("/settings/braipDeactivationEnabled", { value: String(deactivationEnabled) }),
      ]);
      toast.success("Configurações salvas!");
      setMessagesDialogOpen(false);
    } catch (err) { toastError(err); } finally { setMessagesLoading(false); }
  };

  if (!loggedInUser?.super) return <ForbiddenPage />;

  // ==================== RENDER HELPERS ====================
  const renderCards = () => (
    <>
      <div className={classes.cardsArea}>
        <Paper
          className={classes.integrationCard}
          elevation={0}
          onClick={() => setView("braip-config")}
        >
          <IconButton
            className={classes.cardMenuBtn}
            size="small"
            onClick={(e) => { e.stopPropagation(); setMenuAnchor(e.currentTarget); }}
          >
            <MoreVertIcon fontSize="small" />
          </IconButton>
          <img
            src="/imagens/flag-br.svg"
            alt="Brasil"
            className={classes.countryFlag}
          />
          <div className={classes.cardLogo}>
            <img src="/imagens/logo-braip.png" alt="Braip" style={{ width: "100%", height: "100%", objectFit: "contain" }} />
          </div>
          <Typography variant="subtitle2" style={{ fontWeight: 600, lineHeight: 1.2 }}>Braip</Typography>
          <Typography variant="caption" color="textSecondary" style={{ lineHeight: 1.3 }}>
            Webhook para assinaturas automáticas
          </Typography>
          <Chip
            label={mappings.length > 0 ? `${mappings.length} produto(s) mapeado(s)` : "Nenhum produto mapeado"}
            size="small"
            style={{
              marginTop: 4,
              height: 20,
              fontSize: "0.65rem",
              fontWeight: 600,
              backgroundColor: mappings.length > 0 ? "rgba(34,197,94,0.12)" : "rgba(245,158,11,0.12)",
              color: mappings.length > 0 ? "#16a34a" : "#d97706",
              border: mappings.length > 0 ? "1px solid #22c55e" : "1px solid #f59e0b",
            }}
          />
        </Paper>
      </div>

      {/* Card context menu */}
      <ChatiaPopover
        open={Boolean(menuAnchor)}
        anchorEl={menuAnchor}
        onClose={() => setMenuAnchor(null)}
        title="Braip"
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <PopoverOptionItem
          icon={<ConfigIcon style={{ color: "#6366f1" }} />}
          label="Configurar"
          onClick={() => { setMenuAnchor(null); setView("braip-config"); }}
        />
        <PopoverOptionItem
          icon={<CartAbandonIcon style={{ color: "#f59e0b" }} />}
          label="Mensagens automáticas"
          onClick={() => { setMenuAnchor(null); setMessagesDialogOpen(true); }}
        />
      </ChatiaPopover>
    </>
  );

  const renderBraipConfig = () => (
    <>
      {/* Webhook URLs */}
      <Paper className={classes.section} variant="outlined">
        <Typography className={classes.sectionTitle} variant="h6">URLs de Webhook</Typography>
        <Typography className={classes.sectionSubtitle}>Configure no painel da Braip para receber notificações de vendas, assinaturas e abandono automaticamente.</Typography>
        <Box mb={2}>
          <Typography variant="body2" style={{ fontWeight: 600, marginBottom: 4 }}>Braip (Vendas + Abandono + Assinatura)</Typography>
          <div className={classes.webhookUrl}>
            <span style={{ flex: 1 }}>{`${backendUrl}/webhook/braip`}</span>
            <Tooltip title="Copiar"><IconButton size="small" onClick={() => handleCopyUrl(`${backendUrl}/webhook/braip`)}><FileCopyOutlinedIcon fontSize="small" /></IconButton></Tooltip>
          </div>
        </Box>
        <Box mt={2} p={2} style={{ backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.03)", borderRadius: 12 }}>
          <Typography variant="caption" color="textSecondary" style={{ lineHeight: 1.6 }}>
            <strong>Como funciona:</strong> Ao receber um pagamento aprovado, o sistema cria automaticamente a empresa e o acesso do cliente.
            Se o pagamento atrasar, uma cobrança é enviada pelo WhatsApp. Após 5 dias sem pagamento, o acesso é bloqueado automaticamente.
            Gerencie os assinantes na rota <strong>/subscribers</strong>.
          </Typography>
        </Box>
      </Paper>

      {/* Mapeamentos */}
      <Paper className={classes.section} variant="outlined">
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
          <div>
            <Typography className={classes.sectionTitle} variant="h6">Mapeamento de Produtos</Typography>
            <Typography className={classes.sectionSubtitle}>Vincule o product_key da Braip a um plano do ChatIA.</Typography>
          </div>
          <Button variant="contained" color="primary" size="small" onClick={() => handleOpenModal()} style={{ borderRadius: 12 }}>
            <AddIcon style={{ marginRight: 4, fontSize: 18 }} /> Novo
          </Button>
        </Box>
        {mappingLoading ? <div className={classes.loadingContainer}><CircularProgress /></div> : (
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Plataforma</TableCell>
                <TableCell>Product Key</TableCell>
                <TableCell>Plan Key</TableCell>
                <TableCell>Nome</TableCell>
                <TableCell>Plano</TableCell>
                <TableCell align="center">Dias</TableCell>
                <TableCell align="center">Auto-Ativar</TableCell>
                <TableCell align="center">Ações</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {mappings.length === 0 && <TableRow><TableCell colSpan={8} align="center" style={{ padding: 24, color: "#999" }}>Nenhum mapeamento cadastrado.</TableCell></TableRow>}
              {mappings.map((m) => (
                <TableRow key={m.id}>
                  <TableCell><Chip label={m.platform?.toUpperCase()} size="small" variant="outlined" color="primary" /></TableCell>
                  <TableCell style={{ fontFamily: "monospace", fontSize: "0.85rem" }}>{m.externalProductId || "-"}</TableCell>
                  <TableCell style={{ fontFamily: "monospace", fontSize: "0.85rem" }}>{m.externalPlanId || "-"}</TableCell>
                  <TableCell>{m.externalProductName || "-"}</TableCell>
                  <TableCell><Chip label={getPlanName(m.planId)} size="small" style={{ backgroundColor: "#6366f1", color: "#fff" }} /></TableCell>
                  <TableCell align="center">{m.durationDays}</TableCell>
                  <TableCell align="center"><Chip label={m.autoActivate ? "Sim" : "Não"} size="small" style={{ backgroundColor: m.autoActivate ? "#4caf50" : "#9e9e9e", color: "#fff" }} /></TableCell>
                  <TableCell align="center">
                    <IconButton size="small" onClick={() => handleOpenModal(m)}><EditIcon fontSize="small" /></IconButton>
                    <IconButton size="small" onClick={() => { setDeletingMapping(m); setConfirmOpen(true); }}><DeleteOutlineIcon fontSize="small" /></IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </Paper>
    </>
  );

  // ==================== MAIN RENDER ====================
  const viewTitles = {
    "cards": "Integrações de Pagamento",
    "braip-config": "Braip - Configuração",
  };

  return (
    <MainContainer>
      <MainHeader>
        <Title>
          {view !== "cards" && (
            <span
              onClick={() => setView("cards")}
              style={{ cursor: "pointer", color: theme.palette.primary.main, marginRight: 8 }}
            >
              Integrações
            </span>
          )}
          {view !== "cards" && " / "}
          {viewTitles[view]}
        </Title>
        {view !== "cards" && (
          <MainHeaderButtonsWrapper>
            <Button variant="outlined" size="small" onClick={() => setView("cards")} style={{ borderRadius: 12 }}>
              Voltar
            </Button>
          </MainHeaderButtonsWrapper>
        )}
      </MainHeader>

      {view === "cards" ? (
        renderCards()
      ) : (
        <Paper className={classes.mainPaper} variant="outlined">
          {view === "braip-config" && renderBraipConfig()}
        </Paper>
      )}

      {/* ==================== DIALOG: Mensagens Automaticas ==================== */}
      <ChatiaDialog
        open={messagesDialogOpen}
        onClose={() => setMessagesDialogOpen(false)}
        title="Mensagens Automáticas"
        maxWidth="sm"
        onSave={handleSaveMessageSettings}
        saveText="Salvar"
        saveLoading={messagesLoading}
      >
        {/* ===== LIGAR / DESLIGAR TODAS ===== */}
        <Box mb={2} display="flex" justifyContent="flex-end" gap={1}>
          {(() => {
            const allOn = abandonEnabled && pixEnabled && accessEnabled && reactivationEnabled && overdueEnabled && deactivationEnabled;
            const toggleAll = (val) => { setAbandonEnabled(val); setPixEnabled(val); setAccessEnabled(val); setReactivationEnabled(val); setOverdueEnabled(val); setDeactivationEnabled(val); };
            return (
              <Button
                size="small"
                variant="outlined"
                onClick={() => toggleAll(!allOn)}
                style={{ borderRadius: 20, textTransform: "none", fontSize: 12, padding: "4px 14px" }}
              >
                {allOn ? "Desativar todas" : "Ativar todas"}
              </Button>
            );
          })()}
        </Box>

        {/* ===== NOME DO AGENTE ===== */}
        <Box mb={3}>
          <TextField
            label="Nome do agente (opcional)"
            variant="outlined"
            size="small"
            fullWidth
            value={agentName}
            onChange={(e) => setAgentName(e.target.value)}
            placeholder="Ex: Ana, Assistente ChatIA"
            helperText="Se preenchido, todas as mensagens serão assinadas com este nome"
          />
        </Box>

        {/* ===== ABANDONO DE CARRINHO ===== */}
        <Box mb={3} p={2} style={{ backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,0.03)" : "rgba(0,0,0,0.02)", borderRadius: 12 }}>
          <ChatiaToggleItem
            label="Carrinho abandonado"
            description="Envia mensagem automaticamente quando o cliente abandona o checkout"
            checked={abandonEnabled}
            onChange={(e) => setAbandonEnabled(e.target.checked)}
          />
          {abandonEnabled && (
            <Box mt={2}>
              <ChatiaPromptField
                label="Mensagem"
                value={abandonMessage}
                onChange={(e) => setAbandonMessage(e.target.value)}
                placeholder="Digite a mensagem de recuperação..."
                rows={6}
                helperText="Suporta formatação WhatsApp: *negrito*, _itálico_, ~riscado~"
                extraContent={
                  <Box>
                    <Typography variant="caption" style={{ fontWeight: 600, display: "block", marginBottom: 4 }}>Campos personalizados (clique para inserir):</Typography>
                    {[
                      { var: "{{nome}}", desc: "Primeiro nome do cliente" },
                      { var: "{{nomeCompleto}}", desc: "Nome completo do cliente" },
                      { var: "{{produto}}", desc: "Nome do produto" },
                      { var: "{{link}}", desc: "Link do checkout" },
                    ].map(({ var: v, desc }) => (
                      <Tooltip key={v} title={`${desc} — clique para inserir`}>
                        <Chip label={v} size="small" className={classes.variableChip} color="primary" variant="outlined" onClick={() => setAbandonMessage((prev) => prev + v)} />
                      </Tooltip>
                    ))}
                  </Box>
                }
              />
              <Box mt={1.5} mb={1.5}>
                <Typography variant="caption" style={{ fontWeight: 600, display: "block", marginBottom: 4 }}>Campos personalizados (clique para inserir):</Typography>
                {[
                  { var: "{{nome}}", desc: "Primeiro nome do cliente" },
                  { var: "{{nomeCompleto}}", desc: "Nome completo do cliente" },
                  { var: "{{produto}}", desc: "Nome do produto" },
                  { var: "{{link}}", desc: "Link do checkout" },
                ].map(({ var: v, desc }) => (
                  <Tooltip key={v} title={`${desc} — clique para inserir`}>
                    <Chip label={v} size="small" className={classes.variableChip} color="primary" variant="outlined" onClick={() => setAbandonMessage((prev) => prev + v)} />
                  </Tooltip>
                ))}
              </Box>
              <Box mt={1} p={1.5} style={{ backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.03)", borderRadius: 8 }}>
                <Typography variant="caption" style={{ fontWeight: 600, display: "block", marginBottom: 2 }}>Prévia:</Typography>
                <Typography variant="body2" style={{ whiteSpace: "pre-wrap", fontSize: "0.82rem" }}>
                  {abandonMessage.replace(/\{\{nome\}\}/g, "João").replace(/\{\{nomeCompleto\}\}/g, "João da Silva").replace(/\{\{produto\}\}/g, "ChatIA Pro").replace(/\{\{link\}\}/g, "https://ev.braip.com/checkout/...")}{agentName ? `\n\n— _${agentName}_` : ""}
                </Typography>
              </Box>
            </Box>
          )}
        </Box>

        {/* ===== PIX GERADO ===== */}
        <Box p={2} style={{ backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,0.03)" : "rgba(0,0,0,0.02)", borderRadius: 12 }}>
          <ChatiaToggleItem
            label="PIX gerado sem pagamento"
            description="Envia mensagem + QR Code + código PIX quando o cliente gera um PIX e não paga"
            checked={pixEnabled}
            onChange={(e) => setPixEnabled(e.target.checked)}
          />
          {pixEnabled && (
            <Box mt={2}>
              <TextField
                label="Tempo de espera (minutos)"
                variant="outlined"
                size="small"
                type="number"
                value={pixDelay}
                onChange={(e) => setPixDelay(Math.max(1, parseInt(e.target.value) || 1))}
                helperText="Aguarda esse tempo antes de enviar. Se o cliente pagar antes, a mensagem não é enviada."
                style={{ marginBottom: 16, width: 220 }}
                inputProps={{ min: 1, max: 1440 }}
              />
              <ChatiaPromptField
                label="Mensagem inicial"
                value={pixMessage}
                onChange={(e) => setPixMessage(e.target.value)}
                placeholder="Mensagem enviada antes do QR Code..."
                rows={6}
                helperText="Após esta mensagem, o QR Code e o código PIX são enviados automaticamente"
                extraContent={
                  <Box>
                    <Typography variant="caption" style={{ fontWeight: 600, display: "block", marginBottom: 4 }}>Campos personalizados (clique para inserir):</Typography>
                    {[
                      { var: "{{nome}}", desc: "Primeiro nome do cliente" },
                      { var: "{{nomeCompleto}}", desc: "Nome completo do cliente" },
                      { var: "{{produto}}", desc: "Nome do produto" },
                    ].map(({ var: v, desc }) => (
                      <Tooltip key={v} title={`${desc} — clique para inserir`}>
                        <Chip label={v} size="small" className={classes.variableChip} color="primary" variant="outlined" onClick={() => setPixMessage((prev) => prev + v)} />
                      </Tooltip>
                    ))}
                  </Box>
                }
              />
              <Box mt={1.5} mb={1.5}>
                <Typography variant="caption" style={{ fontWeight: 600, display: "block", marginBottom: 4 }}>Campos personalizados (clique para inserir):</Typography>
                {[
                  { var: "{{nome}}", desc: "Primeiro nome do cliente" },
                  { var: "{{nomeCompleto}}", desc: "Nome completo do cliente" },
                  { var: "{{produto}}", desc: "Nome do produto" },
                ].map(({ var: v, desc }) => (
                  <Tooltip key={v} title={`${desc} — clique para inserir`}>
                    <Chip label={v} size="small" className={classes.variableChip} color="primary" variant="outlined" onClick={() => setPixMessage((prev) => prev + v)} />
                  </Tooltip>
                ))}
              </Box>
              <Box mt={1} p={1.5} style={{ backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.03)", borderRadius: 8 }}>
                <Typography variant="caption" style={{ fontWeight: 600, display: "block", marginBottom: 2 }}>Prévia (4 mensagens):</Typography>
                <Typography variant="body2" style={{ whiteSpace: "pre-wrap", fontSize: "0.82rem", marginBottom: 8 }}>
                  <strong>1.</strong> {pixMessage.replace(/\{\{nome\}\}/g, "João").replace(/\{\{nomeCompleto\}\}/g, "João da Silva").replace(/\{\{produto\}\}/g, "ChatIA Pro")}{agentName ? `\n\n— _${agentName}_` : ""}
                </Typography>
                <Typography variant="body2" style={{ fontSize: "0.82rem", marginBottom: 4, color: theme.palette.text.secondary }}>
                  <strong>2.</strong> [Imagem QR Code do PIX]
                </Typography>
                <Typography variant="body2" style={{ fontSize: "0.82rem", marginBottom: 4 }}>
                  <strong>3.</strong> Código do PIX (copia e cola) 👇
                </Typography>
                <Typography variant="body2" style={{ fontSize: "0.82rem", fontFamily: "monospace", color: theme.palette.text.secondary }}>
                  <strong>4.</strong> 00020101021226820014br.gov.bcb.pix...
                </Typography>
              </Box>
            </Box>
          )}
        </Box>

        {/* ===== ACESSO CRIADO (novo cliente) ===== */}
        <Box mt={3} mb={3} p={2} style={{ backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,0.03)" : "rgba(0,0,0,0.02)", borderRadius: 12 }}>
          <ChatiaToggleItem
            label="Pagamento aprovado (novo cliente)"
            description="Envia automaticamente as credenciais de acesso quando um novo cliente realiza o pagamento"
            checked={accessEnabled}
            onChange={(e) => setAccessEnabled(e.target.checked)}
          />
          {accessEnabled && (
          <Box mt={2}>
          <ChatiaPromptField
            label="Mensagem de acesso"
            value={accessMessage}
            onChange={(e) => setAccessMessage(e.target.value)}
            placeholder="Mensagem com credenciais de acesso..."
            rows={6}
            helperText="Enviada automaticamente ao criar o acesso do cliente"
            extraContent={
              <Box>
                <Typography variant="caption" style={{ fontWeight: 600, display: "block", marginBottom: 4 }}>Campos personalizados (clique para inserir):</Typography>
                {[
                  { var: "{{nome}}", desc: "Primeiro nome do cliente" },
                  { var: "{{nomeCompleto}}", desc: "Nome completo do cliente" },
                  { var: "{{email}}", desc: "Email de acesso" },
                  { var: "{{senha}}", desc: "Senha gerada" },
                  { var: "{{link}}", desc: "Link do sistema" },
                ].map(({ var: v, desc }) => (
                  <Tooltip key={v} title={`${desc} — clique para inserir`}>
                    <Chip label={v} size="small" className={classes.variableChip} color="primary" variant="outlined" onClick={() => setAccessMessage((prev) => prev + v)} />
                  </Tooltip>
                ))}
              </Box>
            }
          />
          <Box mt={1.5} mb={1.5}>
            <Typography variant="caption" style={{ fontWeight: 600, display: "block", marginBottom: 4 }}>Campos personalizados (clique para inserir):</Typography>
            {[
              { var: "{{nome}}", desc: "Primeiro nome do cliente" },
              { var: "{{nomeCompleto}}", desc: "Nome completo do cliente" },
              { var: "{{email}}", desc: "Email de acesso" },
              { var: "{{senha}}", desc: "Senha gerada" },
              { var: "{{link}}", desc: "Link do sistema" },
            ].map(({ var: v, desc }) => (
              <Tooltip key={v} title={`${desc} — clique para inserir`}>
                <Chip label={v} size="small" className={classes.variableChip} color="primary" variant="outlined" onClick={() => setAccessMessage((prev) => prev + v)} />
              </Tooltip>
            ))}
          </Box>
          <Box mt={1} p={1.5} style={{ backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.03)", borderRadius: 8 }}>
            <Typography variant="caption" style={{ fontWeight: 600, display: "block", marginBottom: 2 }}>Prévia:</Typography>
            <Typography variant="body2" style={{ whiteSpace: "pre-wrap", fontSize: "0.82rem" }}>
              {accessMessage.replace(/\{\{nome\}\}/g, "João").replace(/\{\{nomeCompleto\}\}/g, "João da Silva").replace(/\{\{email\}\}/g, "joao@email.com").replace(/\{\{senha\}\}/g, "a1b2c3d4").replace(/\{\{link\}\}/g, "https://app.chatia.com.br")}{agentName ? `\n\n— _${agentName}_` : ""}
            </Typography>
          </Box>
          </Box>
          )}
        </Box>

        {/* ===== ACESSO REATIVADO (cliente existente) ===== */}
        <Box p={2} style={{ backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,0.03)" : "rgba(0,0,0,0.02)", borderRadius: 12 }}>
          <ChatiaToggleItem
            label="Pagamento aprovado (cliente existente)"
            description="Envia automaticamente um aviso de reativação quando um cliente existente renova o pagamento"
            checked={reactivationEnabled}
            onChange={(e) => setReactivationEnabled(e.target.checked)}
          />
          {reactivationEnabled && (
          <Box mt={2}>
          <ChatiaPromptField
            label="Mensagem de reativação"
            value={reactivationMessage}
            onChange={(e) => setReactivationMessage(e.target.value)}
            placeholder="Mensagem de reativação de acesso..."
            rows={6}
            helperText="Enviada quando o acesso do cliente é reativado"
            extraContent={
              <Box>
                <Typography variant="caption" style={{ fontWeight: 600, display: "block", marginBottom: 4 }}>Campos personalizados (clique para inserir):</Typography>
                {[
                  { var: "{{nome}}", desc: "Primeiro nome do cliente" },
                  { var: "{{nomeCompleto}}", desc: "Nome completo do cliente" },
                  { var: "{{email}}", desc: "Email de acesso" },
                  { var: "{{link}}", desc: "Link do sistema" },
                ].map(({ var: v, desc }) => (
                  <Tooltip key={v} title={`${desc} — clique para inserir`}>
                    <Chip label={v} size="small" className={classes.variableChip} color="primary" variant="outlined" onClick={() => setReactivationMessage((prev) => prev + v)} />
                  </Tooltip>
                ))}
              </Box>
            }
          />
          <Box mt={1.5} mb={1.5}>
            <Typography variant="caption" style={{ fontWeight: 600, display: "block", marginBottom: 4 }}>Campos personalizados (clique para inserir):</Typography>
            {[
              { var: "{{nome}}", desc: "Primeiro nome do cliente" },
              { var: "{{nomeCompleto}}", desc: "Nome completo do cliente" },
              { var: "{{email}}", desc: "Email de acesso" },
              { var: "{{link}}", desc: "Link do sistema" },
            ].map(({ var: v, desc }) => (
              <Tooltip key={v} title={`${desc} — clique para inserir`}>
                <Chip label={v} size="small" className={classes.variableChip} color="primary" variant="outlined" onClick={() => setReactivationMessage((prev) => prev + v)} />
              </Tooltip>
            ))}
          </Box>
          <Box mt={1} p={1.5} style={{ backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.03)", borderRadius: 8 }}>
            <Typography variant="caption" style={{ fontWeight: 600, display: "block", marginBottom: 2 }}>Prévia:</Typography>
            <Typography variant="body2" style={{ whiteSpace: "pre-wrap", fontSize: "0.82rem" }}>
              {reactivationMessage.replace(/\{\{nome\}\}/g, "João").replace(/\{\{nomeCompleto\}\}/g, "João da Silva").replace(/\{\{email\}\}/g, "joao@email.com").replace(/\{\{link\}\}/g, "https://app.chatia.com.br")}{agentName ? `\n\n— _${agentName}_` : ""}
            </Typography>
          </Box>
          </Box>
          )}
        </Box>

        {/* ===== COBRANÇA POR ATRASO ===== */}
        <Box mt={3} mb={3} p={2} style={{ backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,0.03)" : "rgba(0,0,0,0.02)", borderRadius: 12 }}>
          <ChatiaToggleItem
            label="Cobrança por pagamento atrasado"
            description="Envia mensagem de cobrança quando o pagamento do cliente está em atraso"
            checked={overdueEnabled}
            onChange={(e) => setOverdueEnabled(e.target.checked)}
          />
          {overdueEnabled && (
            <Box mt={2}>
              <Box mb={2}>
                <TextField
                  label="Enviar após (dias)"
                  variant="outlined"
                  size="small"
                  type="number"
                  value={overdueDelay}
                  onChange={(e) => setOverdueDelay(Math.max(0, parseInt(e.target.value) || 0))}
                  helperText="Dias após o atraso para enviar"
                  inputProps={{ min: 0, max: 30 }}
                  style={{ width: 180 }}
                />
              </Box>
              <Box mb={2}>
                <ChatiaToggleItem
                  label="Cobrar mais de uma vez"
                  description=""
                  checked={overdueRepeat}
                  onChange={(e) => setOverdueRepeat(e.target.checked)}
                />
              </Box>
              <Grid container spacing={2} style={{ marginBottom: 12 }}>
                {overdueRepeat && (
                  <>
                    <Grid item xs={6} sm={4}>
                      <TextField
                        label="Quantas vezes"
                        variant="outlined"
                        size="small"
                        type="number"
                        fullWidth
                        value={overdueRepeatTimes}
                        onChange={(e) => setOverdueRepeatTimes(Math.max(1, parseInt(e.target.value) || 1))}
                        inputProps={{ min: 1, max: 10 }}
                      />
                    </Grid>
                    <Grid item xs={6} sm={4}>
                      <TextField
                        label="Intervalo (dias)"
                        variant="outlined"
                        size="small"
                        type="number"
                        fullWidth
                        value={overdueRepeatInterval}
                        onChange={(e) => setOverdueRepeatInterval(Math.max(1, parseInt(e.target.value) || 1))}
                        helperText="Dias entre cada cobrança"
                        inputProps={{ min: 1, max: 15 }}
                      />
                    </Grid>
                  </>
                )}
              </Grid>
              <ChatiaPromptField
                label="Mensagem de cobrança"
                value={overdueMessage}
                onChange={(e) => setOverdueMessage(e.target.value)}
                placeholder="Mensagem de cobrança por atraso..."
                rows={6}
                helperText="Enviada quando o pagamento está em atraso"
                extraContent={
                  <Box>
                    <Typography variant="caption" style={{ fontWeight: 600, display: "block", marginBottom: 4 }}>Campos personalizados (clique para inserir):</Typography>
                    {[
                      { var: "{{nome}}", desc: "Primeiro nome do cliente" },
                      { var: "{{nomeCompleto}}", desc: "Nome completo do cliente" },
                      { var: "{{produto}}", desc: "Nome do produto" },
                    ].map(({ var: v, desc }) => (
                      <Tooltip key={v} title={`${desc} — clique para inserir`}>
                        <Chip label={v} size="small" className={classes.variableChip} color="primary" variant="outlined" onClick={() => setOverdueMessage((prev) => prev + v)} />
                      </Tooltip>
                    ))}
                  </Box>
                }
              />
              <Box mt={1.5} mb={1.5}>
                <Typography variant="caption" style={{ fontWeight: 600, display: "block", marginBottom: 4 }}>Campos personalizados (clique para inserir):</Typography>
                {[
                  { var: "{{nome}}", desc: "Primeiro nome do cliente" },
                  { var: "{{nomeCompleto}}", desc: "Nome completo do cliente" },
                  { var: "{{produto}}", desc: "Nome do produto" },
                ].map(({ var: v, desc }) => (
                  <Tooltip key={v} title={`${desc} — clique para inserir`}>
                    <Chip label={v} size="small" className={classes.variableChip} color="primary" variant="outlined" onClick={() => setOverdueMessage((prev) => prev + v)} />
                  </Tooltip>
                ))}
              </Box>
              <Box mt={1} p={1.5} style={{ backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.03)", borderRadius: 8 }}>
                <Typography variant="caption" style={{ fontWeight: 600, display: "block", marginBottom: 2 }}>Prévia:</Typography>
                <Typography variant="body2" style={{ whiteSpace: "pre-wrap", fontSize: "0.82rem" }}>
                  {overdueMessage.replace(/\{\{nome\}\}/g, "João").replace(/\{\{nomeCompleto\}\}/g, "João da Silva").replace(/\{\{produto\}\}/g, "ChatIA Pro")}{agentName ? `\n\n— _${agentName}_` : ""}
                </Typography>
              </Box>
            </Box>
          )}
        </Box>

        {/* ===== DESATIVAÇÃO POR FALTA DE PAGAMENTO ===== */}
        <Box p={2} style={{ backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,0.03)" : "rgba(0,0,0,0.02)", borderRadius: 12 }}>
          <ChatiaToggleItem
            label="Acesso desativado"
            description="Enviada automaticamente quando o acesso é desativado por falta de pagamento"
            checked={deactivationEnabled}
            onChange={(e) => setDeactivationEnabled(e.target.checked)}
          />
          {deactivationEnabled && (
          <Box mt={2}>
          <ChatiaPromptField
            label="Mensagem de desativação"
            value={deactivationMessage}
            onChange={(e) => setDeactivationMessage(e.target.value)}
            placeholder="Mensagem informando desativação..."
            rows={6}
            helperText="Enviada ao desativar o acesso do cliente"
            extraContent={
              <Box>
                <Typography variant="caption" style={{ fontWeight: 600, display: "block", marginBottom: 4 }}>Campos personalizados (clique para inserir):</Typography>
                {[
                  { var: "{{nome}}", desc: "Primeiro nome do cliente" },
                  { var: "{{nomeCompleto}}", desc: "Nome completo do cliente" },
                  { var: "{{produto}}", desc: "Nome do produto" },
                ].map(({ var: v, desc }) => (
                  <Tooltip key={v} title={`${desc} — clique para inserir`}>
                    <Chip label={v} size="small" className={classes.variableChip} color="primary" variant="outlined" onClick={() => setDeactivationMessage((prev) => prev + v)} />
                  </Tooltip>
                ))}
              </Box>
            }
          />
          <Box mt={1.5} mb={1.5}>
            <Typography variant="caption" style={{ fontWeight: 600, display: "block", marginBottom: 4 }}>Campos personalizados (clique para inserir):</Typography>
            {[
              { var: "{{nome}}", desc: "Primeiro nome do cliente" },
              { var: "{{nomeCompleto}}", desc: "Nome completo do cliente" },
              { var: "{{produto}}", desc: "Nome do produto" },
            ].map(({ var: v, desc }) => (
              <Tooltip key={v} title={`${desc} — clique para inserir`}>
                <Chip label={v} size="small" className={classes.variableChip} color="primary" variant="outlined" onClick={() => setDeactivationMessage((prev) => prev + v)} />
              </Tooltip>
            ))}
          </Box>
          <Box mt={1} p={1.5} style={{ backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.03)", borderRadius: 8 }}>
            <Typography variant="caption" style={{ fontWeight: 600, display: "block", marginBottom: 2 }}>Prévia:</Typography>
            <Typography variant="body2" style={{ whiteSpace: "pre-wrap", fontSize: "0.82rem" }}>
              {deactivationMessage.replace(/\{\{nome\}\}/g, "João").replace(/\{\{nomeCompleto\}\}/g, "João da Silva").replace(/\{\{produto\}\}/g, "ChatIA Pro")}{agentName ? `\n\n— _${agentName}_` : ""}
            </Typography>
          </Box>
          </Box>
          )}
        </Box>
      </ChatiaDialog>

      {/* ==================== DIALOG: Mapeamento ==================== */}
      <ChatiaDialog
        open={modalOpen}
        onClose={() => { setModalOpen(false); setSelectedMapping(null); }}
        title={selectedMapping ? "Editar Mapeamento" : "Novo Mapeamento"}
        maxWidth="sm"
        onSave={handleSaveMapping}
        saveText={selectedMapping ? "Atualizar" : "Criar"}
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <FormControl variant="outlined" fullWidth size="small">
              <InputLabel>Plataforma</InputLabel>
              <Select
                value={formData.platform}
                onChange={(e) => setFormData({ ...formData, platform: e.target.value })}
                label="Plataforma"
                IconComponent={SelectArrowIcon}
                MenuProps={mappingSelectMenuProps}
                style={{ borderRadius: 12 }}
              >
                <MenuItem value="braip">Braip</MenuItem>
                <MenuItem value="hotmart">Hotmart</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField label="Product Key" variant="outlined" size="small" fullWidth value={formData.externalProductId} onChange={(e) => setFormData({ ...formData, externalProductId: e.target.value })} helperText="Ex: pro5w34kz" />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField label="Plan Key" variant="outlined" size="small" fullWidth value={formData.externalPlanId} onChange={(e) => setFormData({ ...formData, externalPlanId: e.target.value })} helperText="Ex: pla6p6er" />
          </Grid>
          <Grid item xs={12}>
            <TextField label="Nome do Produto" variant="outlined" size="small" fullWidth value={formData.externalProductName} onChange={(e) => setFormData({ ...formData, externalProductName: e.target.value })} helperText="Opcional, para referência" />
          </Grid>
          <Grid item xs={12}>
            <FormControl variant="outlined" fullWidth size="small" required>
              <InputLabel>Plano ChatIA</InputLabel>
              <Select
                value={formData.planId}
                onChange={(e) => setFormData({ ...formData, planId: e.target.value })}
                label="Plano ChatIA"
                IconComponent={SelectArrowIcon}
                MenuProps={mappingSelectMenuProps}
                style={{ borderRadius: 12 }}
              >
                {plans.map((p) => <MenuItem key={p.id} value={p.id}>{p.name}</MenuItem>)}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControl variant="outlined" fullWidth size="small" required>
              <InputLabel>Tipo de cobrança</InputLabel>
              <Select
                value={formData.billingType}
                onChange={(e) => {
                  const bt = e.target.value;
                  const rec = bt === "recurring" ? (formData.recurrence || "monthly") : null;
                  const days = bt === "free" ? 36500 : bt === "recurring" ? recurrenceToDays(rec) : formData.durationDays;
                  setFormData({ ...formData, billingType: bt, recurrence: rec, durationDays: days });
                }}
                label="Tipo de cobrança"
                IconComponent={SelectArrowIcon}
                MenuProps={mappingSelectMenuProps}
                style={{ borderRadius: 12 }}
              >
                <MenuItem value="single">Único</MenuItem>
                <MenuItem value="recurring">Recorrente</MenuItem>
                <MenuItem value="free">Grátis</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          {formData.billingType === "recurring" && (
            <Grid item xs={12} sm={6}>
              <FormControl variant="outlined" fullWidth size="small" required>
                <InputLabel>Recorrência</InputLabel>
                <Select
                  value={formData.recurrence || "monthly"}
                  onChange={(e) => setFormData({ ...formData, recurrence: e.target.value, durationDays: recurrenceToDays(e.target.value) })}
                  label="Recorrência"
                  IconComponent={SelectArrowIcon}
                  MenuProps={mappingSelectMenuProps}
                  style={{ borderRadius: 12 }}
                >
                  <MenuItem value="weekly">Semanal</MenuItem>
                  <MenuItem value="biweekly">Quinzenal</MenuItem>
                  <MenuItem value="monthly">Mensal</MenuItem>
                  <MenuItem value="quarterly">Trimestral</MenuItem>
                  <MenuItem value="semiannual">Semestral</MenuItem>
                  <MenuItem value="annual">Anual</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          )}
          {formData.billingType === "single" && (
            <Grid item xs={12} sm={6}>
              <TextField label="Duração (dias)" variant="outlined" size="small" fullWidth type="number" value={formData.durationDays} onChange={(e) => setFormData({ ...formData, durationDays: parseInt(e.target.value) || 30 })} helperText="Dias de acesso após pagamento" />
            </Grid>
          )}
          <Grid item xs={12}>
            <ChatiaToggleItem
              label="Criar empresa automaticamente"
              description="Ao receber pagamento aprovado, cria a empresa e o usuario admin"
              checked={formData.autoActivate}
              onChange={(e) => setFormData({ ...formData, autoActivate: e.target.checked })}
            />
          </Grid>
        </Grid>
      </ChatiaDialog>

      {/* Confirmação de exclusão */}
      <ConfirmationModal title="Excluir Mapeamento" open={confirmOpen} onClose={() => { setConfirmOpen(false); setDeletingMapping(null); }} onConfirm={() => handleDeleteMapping(deletingMapping?.id)}>
        Excluir o mapeamento "{deletingMapping?.externalProductName || deletingMapping?.externalProductId}"?
      </ConfirmationModal>
    </MainContainer>
  );
};

export default PaymentConfig;
